import React from "react";
import { useCurrentProject } from "@radarly/core/project/use-cases";
import { PostsCard } from "@radarly/models/cards";
import { isPictureWallDataviz } from "@radarly/models/dataviz";
import { useFragment } from "../fragment";
import { CardProps } from "../model";
import PictureWall from "./picture-wall";
import TopPosts from "./top-posts";

const RadarlyPostsCards = ({
  card,
  clause,
  from,
  to,
  height,
  openPostsPanel,
  timezone,
  forceReload,
  readOnly,
  nowDate,
}: CardProps<PostsCard>) => {
  const project = useCurrentProject();
  const fragment = useFragment(card.fragments[0], clause, from, to, timezone);
  const dataviz = card.dataviz;
  const title = card.title;

  return isPictureWallDataviz(dataviz) ? (
    <PictureWall
      fragment={fragment}
      project={project}
      dataviz={dataviz}
      title={title}
      height={height}
      openPostsPanel={readOnly ? null : openPostsPanel}
      timezone={timezone}
      forceReload={forceReload}
      nowDate={nowDate}
    />
  ) : (
    <TopPosts
      fragment={fragment}
      project={project}
      dataviz={dataviz}
      title={title}
      height={height}
      openPostsPanel={readOnly ? null : openPostsPanel}
      timezone={timezone}
      forceReload={forceReload}
      nowDate={nowDate}
    />
  );
};

export default RadarlyPostsCards;
